import React from 'react';

function Clients() {
  const logos = [
    { src: '/logo/indomaret.png', alt: 'Indomaret' },
    { src: '/logo/tiket.png', alt: 'Tiket' },
    { src: '/logo/colorobbia.png', alt: 'Colorobbia' },
    { src: '/logo/citraborneo.png', alt: 'Citra Borneo' },
    { src: '/logo/lifepack.png', alt: 'Lifepack' },
    { src: '/logo/payfazz.png', alt: 'Payfazz' },
  ];

  return (
    <section className="bg-gray-50 py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">
        <p className="text-gray-950 text-sm text-center uppercase tracking-widest mb-10">
          Trusted by leading companies
        </p>
      </div>

      {/* Marquee wrapper — fades edges, hides overflow */}
      <div className="relative w-full">
        {/* Left fade */}
        <div className="absolute left-0 top-0 h-full w-16 sm:w-32 bg-gradient-to-r from-gray-50 to-transparent z-10 pointer-events-none" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 h-full w-16 sm:w-32 bg-gradient-to-l from-gray-50 to-transparent z-10 pointer-events-none" />

        <div className="flex overflow-hidden">
          <div className="flex items-center gap-16 animate-marquee shrink-0">
            {/* First set */}
            {logos.map((logo, i) => (
              <img
                key={`a-${i}`}
                src={logo.src}
                alt={logo.alt}
                className="h-10 sm:h-12 w-auto shrink-0"
              />
            ))}
            {/* Duplicate set for seamless loop */}
            {logos.map((logo, i) => (
              <img
                key={`b-${i}`}
                src={logo.src}
                alt={logo.alt}
                className="h-10 sm:h-12 w-auto shrink-0"
              />
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 25s linear infinite;
        }
      `}</style>
    </section>
  );
}

export default Clients;